var PhoneValidate = {

    countries: [],
    demoName: "",
    elements: {},
    messages: {},
    minNumsRequired: 0,
    settings: {},
    additionalInfoTemplate: '<div class="row bottom-ten"><div class="col-sm-6 text-bold">{0}</div><div class="col-sm-6 text-gray-dark">{1}</div></div>',
    timeout: null,
    urls: {},

    config: function (demoName, elements, urls, messages, settings, timeout) {
        PhoneValidate.demoName = demoName;
        PhoneValidate.elements = elements;
        PhoneValidate.urls = urls;
        PhoneValidate.messages = messages;
        PhoneValidate.minNumsRequired = isNaN(Number(settings.minNumsRequired)) ? 0 : Number(settings.minNumsRequired);
        PhoneValidate.settings = settings;
        PhoneValidate.timeout = timeout;

        $(function () {
            $("#" + PhoneValidate.elements.containerId).inView(PhoneValidate.init);
        });
    },

    init: function () {
        // Get and set rate limit for this user
        PhoneValidate.rateLimit.setInitial();

        // Populate the list of countries after we get the geolocation
        Utilities.geolocation.runAfter(function () {
            PhoneValidate.getSupportedCountries();
        });

        // Search field listener
        $(document.body).on("keyup change paste input", "#" + PhoneValidate.elements.searchFieldId, function (e) {
            PhoneValidate.search.keyup(e);
        });

        // Search button listener
        $(document.body).on("click", "#" + PhoneValidate.elements.searchBtnId, function () {
            PhoneValidate.search.start();
        });

        // Retry button listener
        $(document.body).on("click", "#" + PhoneValidate.elements.retryBtnId, function () {
            PhoneValidate.toggleState();
            setTimeout(function () {
                $("#" + PhoneValidate.elements.searchFieldId).focus();
            }, 0);
        });
    },

    getSupportedCountries: function () {
        if (PhoneValidate.search.enabled) {
            var req = {
                type: "POST",
                url: PhoneValidate.urls.getSupportedCountries,
                success: function (result) {

                    var countryNames = [],
                        isNotDuplicate = function (country) {
                            var position = $.inArray(country.Name, countryNames);
                            countryNames.push(country.Name);
                            return position < 0;
                        };

                    $.each(result, function (i) {
                        // Populate countries object
                        var country = result[i];
                        if (isNotDuplicate(country)) {
                            PhoneValidate.countries.push({
                                isoCode: country.IsoCode,
                                name: country.Name,
                                dialingCode: country.DialingCode
                            });
                        }

                        // Set the default country based on geolocation, if appropriate
                        if (PhoneValidate.settings.useGeolocation && country.IsoCode === Utilities.geolocation.current) {
                            PhoneValidate.settings.defaultCountry = country.IsoCode;
                        }
                    });

                    // Sort the datasets object by country name
                    var sortedCountries = PhoneValidate.countries;
                    sortedCountries.sort(Utilities.sortData("name"));

                    // Populate the Country dropdown box
                    $.each(sortedCountries, function (i) {
                        $("#" + PhoneValidate.elements.countryFieldId).append(
                            $("<option/>", {
                                "value": sortedCountries[i].isoCode,
                                "data-iso": sortedCountries[i].isoCode,
                                "data-dialing": sortedCountries[i].dialingCode,
                                text: PhoneValidate.settings.useDialingCodeDropdown ? sortedCountries[i].name + " (" + sortedCountries[i].dialingCode + ")" : sortedCountries[i].name
                            })
                        );
                    });

                    // Update the fancy dropdown to contain the dynamically-loaded countries
                    $("#" + PhoneValidate.elements.countryFieldId).siblings(".dropdown").not(".address-input").remove();

                    // Select the geolocation default country, or the default country set by the content editor
                    $("#" + PhoneValidate.elements.countryFieldId).val(PhoneValidate.settings.defaultCountry);

                    if (PhoneValidate.settings.useDialingCodeDropdown) {
                        window.createDropdown($("#" + PhoneValidate.elements.countryFieldId), true, "data-dialing");
                    }
                    else {
                        window.createDropdown($("#" + PhoneValidate.elements.countryFieldId));
                    }

                    // Set initial search options
                    PhoneValidate.setSearchOptions();

                    // Bind country change to focus on search field
                    $("#" + PhoneValidate.elements.countryFieldId).on("change", PhoneValidate.countryChanged);
                },
                error: function (jqXHR) {
                    PhoneValidate.search.handleError({
                        statusText: "Could not retrieve countries",
                        status: jqXHR.status
                    });
                },
                dataType: "json",
                timeout: PhoneValidate.timeout
            };
            if (!Utilities.isNullOrEmpty(PhoneValidate.settings.version) && PhoneValidate.settings.version !== 0) {
                req.data = { version: PhoneValidate.settings.version };
            }
            $.ajax(req);
        }
    },

    countryChanged: function () {
        PhoneValidate.search.input.clear();
        PhoneValidate.setSearchOptions();
        setTimeout(function () {
            $("#" + PhoneValidate.elements.searchFieldId).focus();
        }, 0);
    },

    setSearchOptions: function () {

        // Set previous country
        PhoneValidate.search.lastCountry = PhoneValidate.search.currentCountry;

        // Set the current country
        if ($("#" + PhoneValidate.elements.countryFieldId).val() !== null) {
            PhoneValidate.search.currentCountry = $("#" + PhoneValidate.elements.countryFieldId).val();
        }
        else {
            PhoneValidate.search.currentCountry = $("#" + PhoneValidate.elements.countryFieldId).find("option").first().attr("value");
        }
    },

    rateLimit: {

        setInitial: function () {
            $.ajax({
                type: "POST",
                url: PhoneValidate.urls.getRateLimit,
                success: function (response) {
                    PhoneValidate.rateLimit.update(response.rateLimit, response.limitReason);
                },
                error: PhoneValidate.search.handleError,
                dataType: "json",
                timeout: PhoneValidate.timeout
            });
        },

        update: function (rateLimit, limitReason) {
            var limitMessage, limitReasonText;

            // Let internal users continue to search if IP blocking is the limitReason
            if (limitReason === "InternalIP") {
                rateLimit = 3;
                limitReasonText = "(Internal IP address)";
            } else if (limitReason === "StaffRole") {
                rateLimit = 3;
                limitReasonText = "(Staff access)";
            } else if (limitReason === "ThrottleLimitReached") {
                limitReasonText = PhoneValidate.messages.throttleLimitReached;
                // Disable searching and highlight warning
                PhoneValidate.search.throttle();
            }

            if (rateLimit > 1) {
                limitMessage = PhoneValidate.messages.searchCountMultiple.replace("{}", rateLimit);
            }
            else if (rateLimit === 1) {
                limitMessage = PhoneValidate.messages.searchCountSingle;
            }
            else {
                limitMessage = PhoneValidate.messages.searchCountNone;
                // Add messages to the limit string for particular reasons
                switch (limitReason) {
                    case "IPDailyLimit":
                        limitReasonText = PhoneValidate.messages.ipDailyBlock;
                        break;
                    case "IPMonthlyLimit":
                        limitReasonText = PhoneValidate.messages.ipMonthlyBlock;
                        break;
                    case "IPBlocked":
                        limitReasonText = PhoneValidate.messages.ipPermanentBlock;
                        break;
                }
                // Disable searching and highlight warning if the rateLimit is less than 1
                PhoneValidate.search.disable.permanent();
            }
            // Update the "searches remaining" text
            if (typeof limitReasonText !== "undefined") {
                limitMessage += "<br />" + Utilities.escapeHtml(limitReasonText);
            }
            $("." + PhoneValidate.elements.rateLimitMessageClass).html(limitMessage);
            PhoneValidate.search.enable();
            PhoneValidate.toggleLoading();
        }
    },

    toggleState: function () {
        $("." + PhoneValidate.elements.stateClass).toggleClass("hidden");
    },

    toggleLoading: function () {
        $("#" + PhoneValidate.elements.containerId).toggleLoaders();
        $("." + PhoneValidate.elements.stateClass + ".toggle-visibility").removeClass("invisible");
    },

    search: {

        enabled: true,
        currentCountry: "",
        lastCountry: "",

        input: {

            value: "",

            clear: function () {
                $("#" + PhoneValidate.elements.searchFieldId).val("");
                PhoneValidate.search.input.value = "";
                PhoneValidate.search.enable();
                PhoneValidate.search.disable.buttonOnly();
            }
        },

        keyup: function (e) {
            var $searchButton = $("#" + PhoneValidate.elements.searchBtnId);
            PhoneValidate.search.input.value = $("#" + PhoneValidate.elements.searchFieldId).val();

            var alphaNumericInput = PhoneValidate.search.input.value.match(/[0-9a-zA-z]/g);

            if (PhoneValidate.search.enabled && alphaNumericInput !== null && alphaNumericInput.length >= PhoneValidate.minNumsRequired) {
                PhoneValidate.search.enable();

                // "Submit" the "form" for the user if they press Enter
                if (e.keyCode === 13) {
                    $searchButton.click();
                }
            }
            else {
                PhoneValidate.search.disable.buttonOnly();
            }
        },

        start: function () {
            if (PhoneValidate.search.enabled) {
                PhoneValidate.search.disable.once();
                PhoneValidate.toggleLoading();

                var phoneNumber = PhoneValidate.settings.prependDialingCodeToSearchValue ?
                                  $("#" + PhoneValidate.elements.countryFieldId + " option:selected").attr("data-dialing") + PhoneValidate.search.input.value :
                                  PhoneValidate.search.input.value;
  
                var data = {
                    phoneNumber: phoneNumber,
                    isoCode: PhoneValidate.search.currentCountry
                };

                if (!Utilities.isNullOrEmpty(PhoneValidate.settings.version) && PhoneValidate.settings.version !== 0) {
                    data.version = PhoneValidate.settings.version;
                }

                $.ajax({
                    type: "POST",
                    url: PhoneValidate.urls.validatePhone,
                    data: data,
                    success: function (result) {
                        if (PhoneValidate.demoName === "ReversePhoneAppendDemo") {
                            PhoneValidate.search.reversePhoneAppendSuccess(result);
                        }
                        else {
                            PhoneValidate.search.phoneValidateSuccess(result);
                        }
                    },
                    error: PhoneValidate.search.handleError,
                    dataType: "json",
                    timeout: PhoneValidate.timeout
                });
            }
        },

        phoneValidateSuccess: function (result) {
            $("[data-status]").hide();
            $("." + PhoneValidate.elements.additionalInfoClass + " div").remove();

            if (result.result !== "") {

                $("#" + PhoneValidate.elements.submittedPhoneId).text(result.number);

                $("[data-status='" + Utilities.escapeHtml(result.result) + "']").show();

                if ($("[data-status='" + Utilities.escapeHtml(result.phoneType) + "']").length > 0) {
                    $("[data-status='phonetype']").show();
                    $("[data-status='" + Utilities.escapeHtml(result.phoneType) + "']").show();
                }

                $("#" + PhoneValidate.elements.portedDateId).text(result.portedDate);
                $("#" + PhoneValidate.elements.disposableNumberId).text(result.disposableNumber);

                // Insert additional info
                if (result.additionalPhoneInfo !== "") {
                    var additionalInfo = JSON.parse(result.additionalPhoneInfo);
                    var additionalInfoContainer = $("." + PhoneValidate.elements.additionalInfoClass);
                    /* jshint ignore:start */
                    for (var key in additionalInfo) {
                        if (!Utilities.isNullOrEmpty(additionalInfo[key])) {
                            var htmlString = PhoneValidate.additionalInfoTemplate;
                            htmlString = htmlString.replace('{0}', key.split(/(?=[A-Z])/).join(' '))
                            htmlString = htmlString.replace('{1}', additionalInfo[key]);
                            additionalInfoContainer.append(htmlString);
                        }
                    }
                    /* jshint ignore:end */
                }

                PhoneValidate.toggleState();
                PhoneValidate.search.input.clear();
                               
                // The button will re-activate when the input changes appropriately
                PhoneValidate.search.disable.once();
            }

            PhoneValidate.rateLimit.update(result.rateLimit, result.limitReason);
            $("#" + PhoneValidate.elements.errorPanelId).hide();
            PhoneValidate.search.webAnalytics();
        },

        reversePhoneAppendSuccess: function (result) {
            $("[data-status]").hide();
            $("." + PhoneValidate.elements.additionalInfoClass).hide();

            if (result.addressCertainty !== "") {

                $("#" + PhoneValidate.elements.submittedPhoneId).text(result.number);

                $("[data-status='" + Utilities.escapeHtml(result.result) + "']").show();

                if (result.result !== "unverified") {
                    $("." + PhoneValidate.elements.additionalInfoClass).show();
                    $("[data-status='" + Utilities.escapeHtml(result.phoneType) + "']").show();
                    $("[data-status='" + Utilities.escapeHtml(result.accountType) + "']").show();
                    if (result.addressCertainty === "noaddress" && result.name === "") {
                        $("[data-status='" + Utilities.escapeHtml(result.addressCertainty) + "noname']").show();
                    } else {
                        $("[data-status='" + Utilities.escapeHtml(result.addressCertainty) + "']").show();
                    }

                    var insertResultOrHideContainer = function (divId, result) {
                        if (result !== "" && $("#" + divId)) {
                            $("#" + divId).parent('div.container').show();
                            $("#" + divId)[0].innerHTML = Utilities.escapeHtml(result);
                        } else {
                            $("#" + divId).parent('div.container').hide();
                        }
                    };

                    insertResultOrHideContainer(PhoneValidate.elements.nameResultId, result.name);
                    insertResultOrHideContainer(PhoneValidate.elements.addressResultId, result.address);
                }
                PhoneValidate.toggleState();
                PhoneValidate.search.input.clear();

                // The button will re-activate when the input changes appropriately
                PhoneValidate.search.disable.once();
            }

            PhoneValidate.rateLimit.update(result.rateLimit, result.limitReason);
            $("#" + PhoneValidate.elements.errorPanelId).hide();
            PhoneValidate.search.webAnalytics();
        },

        webAnalytics: function (event) {
            // Push GTM dataLayer event for successful Phone validation
            Utilities.trackEvent({
                'event': PhoneValidate.demoName
            });
        },

        enable: function () {
            if (PhoneValidate.search.enabled) {
                $("#" + PhoneValidate.elements.searchFieldId).removeAttr("disabled");
                if (PhoneValidate.search.input.value !== "") {
                    $("#" + PhoneValidate.elements.searchBtnId).removeAttr("disabled");
                }
            }
        },

        disable: {

            once: function () {
                $("#" + PhoneValidate.elements.searchFieldId).attr("disabled", "disabled");
                $("#" + PhoneValidate.elements.searchBtnId).attr("disabled", "disabled");
            },

            buttonOnly: function () {
                $("#" + PhoneValidate.elements.searchBtnId).attr("disabled", "disabled");
            },

            permanent: function () {

                // Check if the parent of the search button already has a free trial button
                var searchButtonParent = $("#" + PhoneValidate.elements.searchBtnId).parent();
                var freeTrialButtonExists = searchButtonParent.find("#" + PhoneValidate.elements.freeTrialBtnId).length > 0;

                // Append a clone of the free trial button to the search container
                var $freeTrialBtn = $("#" + PhoneValidate.elements.freeTrialBtnId);

                if (!freeTrialButtonExists) {
                    $freeTrialBtn.clone().insertAfter("#" + PhoneValidate.elements.searchBtnId);
                    $freeTrialBtn.parent().removeAttr("class").addClass("col-sm-12 col-md-10");
                    $("#" + PhoneValidate.elements.retryBtnId).parent().addClass("hidden");
                    $("#" + PhoneValidate.elements.searchFieldId).parent().addClass("hidden");
                }

                // Hide search field and buttons
                // $("#" + PhoneValidate.elements.retryBtnId).parent().addClass("hidden");
                $("#" + PhoneValidate.elements.retryBtnId).addClass("hidden");
                $("#" + PhoneValidate.elements.searchBtnId).addClass("hidden");
                // $("#" + PhoneValidate.elements.searchFieldId).parent().addClass("hidden");

                // Turn the rate limit message into an alert
                $("." + PhoneValidate.elements.rateLimitMessageClass).parent(".help-block")
                    .addClass("alert alert-danger")
                    .removeClass("help-block");

                // Disable searching
                PhoneValidate.search.disable.once();
                PhoneValidate.search.enabled = false;
            }
        },

        throttle: function() {
            // Turn the rate limit message into a warning
            $("." + PhoneValidate.elements.rateLimitMessageClass).parent(".help-block")
            .addClass("alert alert-warning")
            .removeClass("help-block");
        },

        handleError: function (error) {
            // Populate the error message
            $("#" + PhoneValidate.elements.errorMessageId).html(PhoneValidate.messages.unknownError);
            // Log underlying error to console
            console.error("Unknown demo error - " +
                Utilities.escapeHtml(error.statusText) +
                " (" + Utilities.escapeHtml(error.status) + ")");
            // Show the error block and hide other content
            PhoneValidate.toggleLoading();
            $("." + PhoneValidate.elements.stateClass).not(".headers").hide();
            $("#" + PhoneValidate.elements.errorPanelId).removeClass("hidden");
            // Activate the retry button
            $(document.body).one("click", "#" + PhoneValidate.elements.retryAfterErrorBtnId, function () {
                $("." + PhoneValidate.elements.stateClass).not(".headers").show();
                $("#" + PhoneValidate.elements.errorPanelId).addClass("hidden");
                PhoneValidate.init();
                PhoneValidate.toggleLoading();
            });
        }
    }
};